import React, { Component } from 'react';
import {Route, Switch} from "react-router-dom";
import Login from './Login';
import LoginExternal from './LoginExternal';
import Register from './Register';
import RegisterEmpresa from './RegisterEmpresa';
import Recover from './Recover';
import ConfirmEmail from './ConfirmEmail';
import SendVerificationEmail from './SendVerificationEmail';
import ConfirmUserData from './ConfirmUserData';	
import Frame from './Frame';
import TagManager from 'react-gtm-module';

import {
  postLogin, postLoginFacebook, postLoginGoogle, postLoginExternal, postCompanyLoginExternal, postLoginEmpresas,
  postRegister, postRegisterFacebook, postRegisterGoogle,
  postRecover,
  postVerifyEmail, postVerifyEmailAgain,
  validateSalesForce,
} from '../api.js';
import { getRecaptchaEnterpriseToken } from '../utils/recaptchaEnterprise';

export default class UserGuest extends Component {
	constructor(props) {
		super(props);
		this.state = {
  			rrss_login_data: null,
			login_type: "personas",
		};
	}	  
	getLoginValidationMessage(result) {
		if (!result) return "Intente más tarde";
		if (result.errors && result.errors.recaptcha_token) {
			return "No se pudo validar la solicitud de seguridad. Intenta nuevamente.";
		}
		if (result.message === "No se pudo validar la solicitud." || result.message === "Solicitud inválida.") {
			return "No se pudo validar la solicitud de seguridad. Intenta nuevamente.";
		}
		return "Intente más tarde";
	}

	async doLogin(email, password, cb) {
		const {toggleMainLoading, createActionNotification, redirect} = this.props;
	    toggleMainLoading(true);

		let recaptchaToken = null;
		try {
			recaptchaToken = await getRecaptchaEnterpriseToken('login_personas');
		} catch (error) {
			toggleMainLoading(false);
			createActionNotification('Error de validación', 'No se pudo validar el inicio de sesión. Intenta nuevamente.', 'error');
			if(cb) cb({message: 'No se pudo validar el inicio de sesión.'});
			return;
		}

	    postLogin(email, password, recaptchaToken, (error, result) => {
			toggleMainLoading(false);

			if(cb) cb(error);
			if(error) return;

			if(result.message === "Correo o contraseña inválidos." && cb) return cb(result);
			if(result.status === "error_cuenta_deshabilitada") {
				if(cb) cb(result);
				return createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
			}
			if(result.status === "error_email_verificado") return redirect("/enviar_codigo_verificacion");
			if(result.status === "error") {
				return createActionNotification("Error de validación", this.getLoginValidationMessage(result), "error");
			}

			toggleMainLoading(true);
			validateSalesForce({tokenLogin:result.data.token}, (err, res) => {
				toggleMainLoading(false);
				const EResponseCodes = {
					ok: 0,
					generalError: -1,
					noRegister: -2,
					noConsent: -3
				}
				let hasConsentSalesForce = true;

				// if(res && 'code' in res) hasConsentSalesForce = res.code !== EResponseCodes.noConsent
				if(cb) cb(err);
				

				this.props.startUser(result.data.person, result.data.token, hasConsentSalesForce);
			})

		});
	}
	doLoginExternal(code, cb) {
	    this.props.toggleMainLoading(true);	    	    
	    postLoginExternal(code, (error, result) => {
	      if(error) {
	   		this.props.toggleMainLoading(false);	  
	        if(cb) cb(error);
	        return;
	    } else {
	    	if(result.message === "Correo o contraseña inválidos.") {
	      		this.props.toggleMainLoading(false);	    		
	    		if(cb) cb(result);
	    	}
	    	else if(result.status === "error_cuenta_deshabilitada") {
	          	this.props.createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
	      		this.props.toggleMainLoading(false);
	          	if(cb) cb(result);
	      }
	      else if(result.status === "error_email_verificado") {
	          if(cb) cb(result);
	          this.props.redirect("/enviar_codigo_verificacion", () => this.props.toggleMainLoading(false));
	      }
	      else if(result.status === "error") {
	      	if(cb) cb(error);
	      	this.props.toggleMainLoading(false);
	      } else {
			TagManager.dataLayer({
				dataLayer:{
				  event:'login_external',
				  user: result.data.person.email
				}
				})

	      	this.props.startUser(result.data.person, result.data.token);
	      }
	  }
	});
	}
	doCompanyExternalLogin(code, cb) {
		this.props.toggleMainLoading(true);	    	    
	    postCompanyLoginExternal(code, (error, result) => {
	      if(error) {
	   		this.props.toggleMainLoading(false);	  
	        if(cb) cb(error);
	        return;
	    } else {
	    	if(result.message === "Correo o contraseña inválidos.") {
	      		this.props.toggleMainLoading(false);	    		
	    		if(cb) cb(result);
	    	}
	    	else if(result.status === "error_cuenta_deshabilitada") {
	          	this.props.createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
	      		this.props.toggleMainLoading(false);
	          	if(cb) cb(result);
	      }
	      else if(result.status === "error_email_verificado") {
	          if(cb) cb(result);
	          this.props.redirect("/enviar_codigo_verificacion", () => this.props.toggleMainLoading(false));
	      }
	      else if(result.status === "error") {
	      	if(cb) cb(error);
	      	this.props.toggleMainLoading(false);
	      } else {
			TagManager.dataLayer({
				dataLayer:{
				  event:'login_company_external',
				  user: result.data.person.email
				}
				})

	      	this.props.startUser(result.data.person, result.data.token, result.data.user_type);
	      }
	  }
	});
	}
	async doLoginEmpresas(email, password, cb) {
		const {
			toggleMainLoading, 
			createActionNotification,
			redirect,
			startUserEmpresas
		} = this.props;

	    toggleMainLoading(true);

		let recaptchaToken = null;
		try {
			recaptchaToken = await getRecaptchaEnterpriseToken('login_empresa');
		} catch (error) {
			toggleMainLoading(false);
			createActionNotification('Error de validación', 'No se pudo validar el inicio de sesión. Intenta nuevamente.', 'error');
			if(cb) cb({message: 'No se pudo validar el inicio de sesión.'});
			return;
		}

	    postLoginEmpresas(email, password, recaptchaToken, (error, result) => {
			toggleMainLoading(false);

	      	if(error || result.message === "Correo o contraseña inválidos.") {
				if(cb) cb(error);
				return;
			}

			if(result.status === "error_cuenta_deshabilitada") {          
				createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
				if(cb) cb(result);
			}
			else if(result.status === "error_email_verificado") {
				redirect("/enviar_codigo_verificacion", () => toggleMainLoading(false));
			}
			else if(result.status === "error") {
				if(result.message === "Cuenta sin empresas asociadas") createActionNotification("Cuenta sin empresas asociadas", "Por favor, Contacta a servicio al cliente.", "error");
				else createActionNotification("Error de validación", this.getLoginValidationMessage(result), "error");
			} else {
			  	TagManager.dataLayer({
					dataLayer:{
						event:'login_empresa',
						user: email
					}
				});
				validateSalesForce({tokenLogin:result.data.token, isCompany: true });
				startUserEmpresas(result.data.company_user, result.data.token, result.data.user_type);
			}
			  
		});
	}
	facebookLoginCallback(resultFB) {
		if(resultFB.status && resultFB.status === "unknown") return;
		this.props.toggleMainLoading(true);		
		postLoginFacebook(resultFB.accessToken, (error, result) => {
			if(error) {
				this.props.toggleMainLoading(false);
				console.log(error);
				return alert(JSON.stringify(error));
			}
			if(result.status === "error_cuenta_deshabilitada") {          
				this.props.toggleMainLoading(false);
				
				this.props.createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
				this.setState({main_loading: false});
			}
			else if(result.status === "ok_falta_registro" || result.status === "error_falta_registro") {
				this.props.toggleMainLoading(false);
				
				this.setState({
					rrss_login_data:{
						name: resultFB.first_name,
						last_name: resultFB.last_name,
						email: resultFB.email,
						token: resultFB.accessToken,
						profile_picture: resultFB.picture.data.url,
						type: "facebook"}}, () => {this.props.redirect("/confirmar_datos"); });
			} else if(result.status === "error_email_verificado") {
				return this.props.redirect("/enviar_codigo_verificacion", () => this.props.toggleMainLoading(false));
			} else {
				TagManager.dataLayer({
					dataLayer:{
					  event:'login_facebook',
					  user: this.state.rrss_login_data.email
					}
					})
				this.props.startUser(result.data.person, result.data.token);
			}

		});
	}
	googleLoginCallback(resultG) {
		this.props.toggleMainLoading(true);
		postLoginGoogle(resultG.credential, (error, result) => {
			if(error) {
				this.props.toggleMainLoading(false);

				//console.log(error);
				return alert(JSON.stringify(error));
			}
			if(result.status === "error_cuenta_deshabilitada") {      
				this.props.createActionNotification("Cuenta deshabilitada", "Por favor, Contacta a servicio al cliente.", "error");
				this.props.toggleMainLoading(false);

				this.setState({main_loading: false});
			}
			else if(result.status === "ok_falta_registro" || result.status === "error_falta_registro") {
				this.props.toggleMainLoading(false);

				this.setState({
					rrss_login_data:{
						token: result.google_token,
						type: "google",
						name: result.person.givenName,
						last_name: result.person.familyName,
						email: result.person.email,
						profile_picture: result.person.picture
					}}, () => this.props.redirect("/confirmar_datos"));
					this.props.toggleMainLoading(false);

			} else if(result.status === "error_email_verificado") {
				this.props.toggleMainLoading(false);

				return this.props.redirect("/enviar_codigo_verificacion", () => this.props.toggleMainLoading(false));				
			} else {
				TagManager.dataLayer({
					dataLayer:{
					  event:'login_google',
					  user: result.data.email
					}
					})
				validateSalesForce({tokenLogin:result.data.token}, (err, res) => {
					const EResponseCodes = {
						ok: 0,
						generalError: -1,
						noRegister: -2,
						noConsent: -3
					}
					let hasConsentSalesForce = true;
	
					// if(res && 'code' in res) hasConsentSalesForce = res.code !== EResponseCodes.noConsent
					
					this.props.startUser(result.data.person, result.data.token, hasConsentSalesForce);
				})
			}

		});
	}
	getRegisterBlockedMessage(result) {
		if(result && result.message === "No se pudo validar la solicitud.") {
			return "No se pudo validar la solicitud de seguridad. Intenta nuevamente.";
		}
		if(result && result.message) return result.message;
		return "Intente más tarde";
	}
	async doRegister(name, last_name, email, email_confirmation, dni, password, password_confirmation, phone, cb) {

		this.props.toggleMainLoading(true);
		let recaptchaToken = null;
		try {
			recaptchaToken = await getRecaptchaEnterpriseToken('register_personas');
		} catch (error) {
			this.props.toggleMainLoading(false);
			this.props.createActionNotification('Error de validación', 'No se pudo validar el registro. Intenta nuevamente.', 'error');
			if(cb) cb({errors: {}});
			return;
		}
		if(this.state.rrss_login_data && this.state.rrss_login_data.type === "facebook") {
			postRegisterFacebook(name, last_name, email, email_confirmation, dni, password, phone, this.state.rrss_login_data.token, this.state.rrss_login_data.profile_picture, recaptchaToken, (error, result) => {
				this.props.toggleMainLoading(false);
				if(error) {
					cb(error);
					return alert("error al registrar");
				}
				if(result.status === "error" && !result.errors) {
					this.props.toggleMainLoading(false);
					this.props.createActionNotification("Error de validación", this.getRegisterBlockedMessage(result), "error");
					return cb({errors: {}});
				}
				if(result.errors) {
					this.props.toggleMainLoading(false);
					return cb({errors: result.errors});
				}
				if(result.status === "ok") {
					TagManager.dataLayer({
						dataLayer:{
						  event:'register_facebook',
						  user: email
						}
						})
					this.facebookLoginCallback({accessToken: this.state.rrss_login_data.token});
				}
				cb();
	      //this.setState({redirect: "/verificar_email"}, () => this.setState({redirect: null}));
	  });
		} else if(this.state.rrss_login_data && this.state.rrss_login_data.type === "google") {
			postRegisterGoogle(name, last_name, email, email_confirmation, dni, password, phone, this.state.rrss_login_data.token, this.state.rrss_login_data.profile_picture, recaptchaToken, (error, result) => {
				this.props.toggleMainLoading(false);
				if(error) {
					cb(error);
					return alert("error al registrar");
				}
				if(result.status === "error" && !result.errors) {
					this.props.toggleMainLoading(false);
					this.props.createActionNotification("Error de validación", this.getRegisterBlockedMessage(result), "error");
					return cb({errors: {}});
				}
				if(result.errors) {
					this.props.toggleMainLoading(false);					
					return cb({errors: result.errors});
				}
				if(result.status === "ok") {
					TagManager.dataLayer({
						dataLayer:{
						  event:'register_google',
						  user: email
						}
						})
					this.googleLoginCallback({credential: this.state.rrss_login_data.token});
				}
				cb();
			});
		} else {
			postRegister(name, last_name, email, email_confirmation, dni, password, password_confirmation, phone, recaptchaToken, (error, result) => {
				this.props.toggleMainLoading(false);
				if(error) {
					cb(error);
					return alert("error al registrar");
				}
				if(result.status === "error" && !result.errors) {
					this.props.toggleMainLoading(false);
					this.props.createActionNotification("Error de validación", this.getRegisterBlockedMessage(result), "error");
					return cb({errors: {}});
				}
				if(result.errors) {
					return cb({errors: result.errors});
				}
				TagManager.dataLayer({
					dataLayer:{
					  event:'register',
					  user: email
					}
					})
				cb();
      			this.props.redirect("/verificar_email");
			});
		}
	}
	doRecover(email, cb, isEmpresas) {
		this.props.toggleMainLoading(true);		
		postRecover(email, (error, result) => {
			this.props.toggleMainLoading(false);			
			if(error) {
				return console.log(error);
			}
			if(result.status === 'ok') {	
				TagManager.dataLayer({
					dataLayer:{
					  event:'recover_password',
					  user: email
					}
					})			
      			this.props.redirect("/login");
				this.props.createActionNotification("Nueva contraseña enviada", "Se ha enviado la nueva contraseña a tu correo");
			}
			cb(error, result);
		}, isEmpresas);
	}	
	doVerifyEmailAgain(email, cb) {
		this.props.toggleMainLoading(true);
		postVerifyEmailAgain(email, (error, result) => {
			this.props.toggleMainLoading(true);			
			if(error) {
				if(cb) cb(error);
				return console.log(error);
			}
			if(result.status === "error") {
				this.props.toggleMainLoading(false);				
			}
			if(result.status === 'ok'){
				this.props.createActionNotification("Correo enviado", "");
      			this.props.redirect("/verificar_email");		
				this.props.toggleMainLoading(false);
			}
			if(cb) cb(null, result);
		});
	}
	doVerifyEmail(code, cb) {
		this.props.toggleMainLoading(true);
		postVerifyEmail(code, (error, result) => {
	      	//console.log("END app.js postVerifyEmail", error, result);
	      	this.props.toggleMainLoading(false);
	      	if(error) {
		        //console.log("entramos al error");
		        return cb(error);
		    } else if(result.status === "ok") {
		        //return this.setState({redirect: "login"}, () => this.setState({redirect: null}));
		        cb(null, result);
		    } else {
		        //console.log("ahora mandaremos cb con null y el result");
		        cb(null, result);

		    }
		});
	}
	isCompanyLogin(loginType) {
		this.setState({login_type: loginType})
	}
	render() {
		return (
			<Switch>
				<Route exact path="/login">
					<Login 
						doLogin={this.doLogin.bind(this)}
						doLoginEmpresas={this.doLoginEmpresas.bind(this)} 
						loginType={this.state.login_type}
						facebookLoginCallback={this.facebookLoginCallback.bind(this)} 
						googleLoginCallback={this.googleLoginCallback.bind(this)} 
						consent_accepted ={this.state.hasConsentSalesForce}
						consent_modal_show={this.state.consent_modal_show}
						/>
				</Route>
				<Route exact path="/login/:code" render={(data)=> {
					return <LoginExternal
							redirect={this.props.redirect}
							code={data.match.params.code}
							isCompany={new URLSearchParams(data.location.search).get("company")}
							doExternalLogin={this.doLoginExternal.bind(this)}
							setLoginType={this.isCompanyLogin.bind(this)}
							doCompanyExternalLogin={this.doCompanyExternalLogin.bind(this)}
							createActionNotification={this.props.createActionNotification}

					/>
				}} />
				<Route exact path="/register">
					<Register doRegister={this.doRegister.bind(this)} facebookLoginCallback={this.facebookLoginCallback.bind(this)} googleLoginCallback={this.googleLoginCallback.bind(this)} />
					{/* <RegisterPrevent redirect={this.props.redirect} /> */}
				</Route>
				<Route exact path="/register/required">
					<Register 
						doRegister={this.doRegister.bind(this)} 
						facebookLoginCallback={this.facebookLoginCallback.bind(this)} googleLoginCallback={this.googleLoginCallback.bind(this)} 
						requiredMessage={true}
						createActionNotification={this.props.createActionNotification}/>
				</Route>
				<Route path="/register_empresa">
					<RegisterEmpresa 
					redirect={this.props.redirect} 
					createActionNotification={this.props.createActionNotification}/>
				</Route>
				<Route exact path="/verificar_email">
					<ConfirmEmail
						redirect={this.props.redirect}
						doVerifyEmail={this.doVerifyEmail.bind(this)}
						createActionNotification={this.props.createActionNotification}
						code={null}/>
				</Route>
				<Route
				path="/verificar_email/:code"
				render={(data)=> {
					return <ConfirmEmail
						redirect={this.props.redirect}
						doVerifyEmail={this.doVerifyEmail.bind(this)}
						createActionNotification={this.props.createActionNotification}
						code={data.match.params.code}
						/>
				}}
				/>
				<Route path="/enviar_codigo_verificacion">
					<SendVerificationEmail doVerifyEmailAgain={this.doVerifyEmailAgain.bind(this)} />
				</Route>
				<Route exact path="/recover">
					<Recover
						doRecover={this.doRecover.bind(this)}
						createActionNotification={this.props.createActionNotification} />
				</Route>
				<Route exact path="/recover/empresas">
					<Recover
						isEmpresas={true}
						doRecover={this.doRecover.bind(this)}
						createActionNotification={this.props.createActionNotification} />
				</Route>
				<Route path="/confirmar_datos">
					<Frame user={{}} location={this.props.location} menuOptions={[	]}>
						<ConfirmUserData data={this.state.rrss_login_data} doRegister={this.doRegister.bind(this)} />
					</Frame>
				</Route>
			</Switch>
			);
	}
}
